var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxItinerary2 = function Svg18PxItinerary2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.5 4.25h3.375a2.375 2.375 0 1 1 0 4.75h-7.75a2.375 2.375 0 1 0 0 4.75H8.5M4.75 6.25a2 2 0 1 0 0-4 2 2 0 0 0 0 4M13.25 15.75a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })));
};
export default Svg18PxItinerary2;